import React from 'react';
import { PercentIcon, TagIcon, ListIcon } from 'lucide-react';
const categoryDiscounts = [{
  category: 'Rør/Manifolder',
  listPrice: 85000,
  discountPercent: 8,
  discountAmount: 6800,
  net: 78200
}, {
  category: 'Styring / WiFi-termostater',
  listPrice: 18500,
  discountPercent: 0,
  discountAmount: 0,
  net: 18500
}, {
  category: 'Fordeler & ventiler',
  listPrice: 12000,
  discountPercent: 0,
  discountAmount: 0,
  net: 12000
}, {
  category: 'Pumper / varmeveksler',
  listPrice: 28000,
  discountPercent: 0,
  discountAmount: 0,
  net: 28000
}, {
  category: 'Ventilationsaggregat / kanaler',
  listPrice: 2000,
  discountPercent: 10,
  discountAmount: 200,
  net: 1800
}];
const totalListPrice = categoryDiscounts.reduce((acc, item) => acc + item.listPrice, 0);
const totalDiscount = categoryDiscounts.reduce((acc, item) => acc + item.discountAmount, 0);
const totalNet = categoryDiscounts.reduce((acc, item) => acc + item.net, 0);
export function DiscountsPanel() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-22">
      <h3 className="text-lg font-medium text-gray-800" data-id="element-23">Rabatter</h3>
      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-24">
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-25">
          <div className="flex items-center" data-id="element-26">
            <PercentIcon size={18} className="text-purple-500 mr-2" data-id="element-27" />
            <h4 className="font-medium" data-id="element-28">Årsrabat</h4>
          </div>
          <div className="mt-3" data-id="element-29">
            <p className="text-xl font-bold text-gray-800" data-id="element-30">11.000 kr</p>
            <p className="text-sm text-gray-500" data-id="element-31">5% af listeprisen</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-32">
          <div className="flex items-center" data-id="element-33">
            <TagIcon size={18} className="text-blue-500 mr-2" data-id="element-34" />
            <h4 className="font-medium" data-id="element-35">Fast rabat</h4>
          </div>
          <div className="mt-3" data-id="element-36">
            <p className="text-xl font-bold text-gray-800" data-id="element-37">5.400 kr</p>
            <p className="text-sm text-gray-500" data-id="element-38">Forhandlet rabat</p>
          </div>
        </div>
        <div className="bg-gray-50 rounded-xl p-4" data-id="element-39">
          <div className="flex items-center" data-id="element-40">
            <ListIcon size={18} className="text-amber-500 mr-2" data-id="element-41" />
            <h4 className="font-medium" data-id="element-42">Kategorirabatter i alt</h4>
          </div>
          <div className="mt-3" data-id="element-43">
            <p className="text-xl font-bold text-gray-800" data-id="element-44">7.000 kr</p>
            <p className="text-sm text-gray-500" data-id="element-45">Fordelt på kategorier</p>
          </div>
        </div>
      </div>
      <div className="mt-6 overflow-x-auto" data-id="element-46">
        <table className="w-full text-sm" data-id="element-47">
          <thead data-id="element-48">
            <tr className="border-b border-gray-200" data-id="element-49">
              <th className="text-left py-3 px-4 font-medium text-gray-500" data-id="element-50">
                Kategori
              </th>
              <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-51">
                Listepris
              </th>
              <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-52">
                Rabat %
              </th>
              <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-53">
                Rabat kr.
              </th>
              <th className="text-right py-3 px-4 font-medium text-gray-500" data-id="element-54">
                Netto
              </th>
            </tr>
          </thead>
          <tbody data-id="element-55">
            {categoryDiscounts.map((item, index) => <tr key={index} className="border-b border-gray-100" data-id="element-56">
                <td className="py-3 px-4" data-id="element-57">{item.category}</td>
                <td className="text-right py-3 px-4" data-id="element-58">
                  {item.listPrice.toLocaleString('da-DK')} kr
                </td>
                <td className="text-right py-3 px-4" data-id="element-59">
                  {item.discountPercent}%
                </td>
                <td className="text-right py-3 px-4" data-id="element-60">
                  {item.discountAmount.toLocaleString('da-DK')} kr
                </td>
                <td className="text-right py-3 px-4" data-id="element-61">
                  {item.net.toLocaleString('da-DK')} kr
                </td>
              </tr>)}
            <tr className="bg-gray-50 font-medium" data-id="element-62">
              <td className="py-3 px-4" data-id="element-63">Total</td>
              <td className="text-right py-3 px-4" data-id="element-64">
                {totalListPrice.toLocaleString('da-DK')} kr
              </td>
              <td className="text-right py-3 px-4" data-id="element-65">-</td>
              <td className="text-right py-3 px-4" data-id="element-66">
                {totalDiscount.toLocaleString('da-DK')} kr
              </td>
              <td className="text-right py-3 px-4" data-id="element-67">
                {totalNet.toLocaleString('da-DK')} kr
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
}